import { render, staticRenderFns } from "./BidDuplicateDialog.vue?vue&type=template&id=3bb9f7de&"
import script from "./BidDuplicateDialog.vue?vue&type=script&lang=js&"
export * from "./BidDuplicateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports